import { render, staticRenderFns } from "./MyvpnbookHeroSection.vue?vue&type=template&id=3a95ce0d&scoped=true"
import script from "./MyvpnbookHeroSection.vue?vue&type=script&lang=js"
export * from "./MyvpnbookHeroSection.vue?vue&type=script&lang=js"
import style0 from "./MyvpnbookHeroSection.vue?vue&type=style&index=0&id=3a95ce0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95ce0d",
  null
  
)

export default component.exports